export default __webpack_public_path__ + "static/media/10 Wating Area Male 2.d54e84d2.jpg";